import React from 'react';
import { motion } from 'framer-motion';
import { FaApple, FaGooglePlay, FaHeart, FaVideo } from 'react-icons/fa';
import Logo from './Logo';

const HeroSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.08
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden w-full">
      {/* Hero Content */}
      <motion.div
        className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center relative z-10 max-w-7xl"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Logo/Brand */}
        <motion.div
          variants={itemVariants}
          className="mb-8"
        >
          <div className=''>
            <img src="/assets/moon-logo.png" alt="Logo" className="w-32 mx-auto" />
            </div>
          <div className=''>
            <img src="/assets/png-logo.png" alt="Logo" className="w-40 mx-auto pb-2" />
            </div>
          {/* <Logo size="xlarge" className="mb-6" /> */}
          <motion.div
            className="flex items-center justify-center gap-2 text-romantic-pink"
            animate={{ rotate: [0, 5, -5, 0] }}
            transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
          >
            <FaHeart className="text-2xl" />
            <FaVideo className="text-2xl" />
            <FaHeart className="text-2xl" />
          </motion.div>
        </motion.div>

        {/* Main Headlines */}
        <motion.div variants={itemVariants} className="mb-8 px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Not like any other
          <br/>
            <span className="gradient-text">dating app</span>
            <br/>
            you’ve tried

          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed px-4">
            Discover the new video dating app, launching exclusively in{' '}
            <span className="text-romantic-pink font-semibold">Bournemouth!</span>
          </p>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div
          variants={itemVariants}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16 px-4"
        >
          <motion.a
            href="https://apps.apple.com/gb/app/datenite-app/id1592597688"
            target="_blank"
            rel="noopener noreferrer"
            className="glow-button bg-gradient-to-r from-romantic-purple to-romantic-pink text-white px-8 py-4 rounded-full font-semibold text-lg flex items-center gap-3 shadow-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaApple className="text-2xl" />
            App Store
          </motion.a>
          
          <motion.a
            href="https://play.google.com/store/apps/details?id=uk.co.datenite.app"
            target="_blank"
            rel="noopener noreferrer"
            className="glow-button bg-gradient-to-r from-romantic-blue to-romantic-purple text-white px-8 py-4 rounded-full font-semibold text-lg flex items-center gap-3 shadow-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaGooglePlay className="text-2xl" />
            Google Play
          </motion.a>
        </motion.div>

        {/* Floating Phone Mockups */}
        
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 border-2 border-white border-opacity-50 rounded-full flex justify-center">
          <motion.div
            className="w-1 h-3 bg-white rounded-full mt-2"
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
